import { isProduction } from '@motimate/utils';

export const MOTIMATE_URL = isProduction() ? 'https://motimate.app' : 'https://staging.motimate.app';

export const SIGNUPS_BACKEND_URL =
  process.env.SIGNUPS_BACKEND_URL ||
  (isProduction() ? 'https://signups-backend.motimate.app' : 'https://signups.motimateapp-staging.com');

export const getServerConfig = () => {
  const { OPEN_REST_API_TOKEN } = process.env;
  if (!OPEN_REST_API_TOKEN) throw Error('OPEN_REST_API_TOKEN is required');

  return { OPEN_REST_API_TOKEN };
};
